import { Button } from '@/components/ui/button';
import PaymentFailedIcon from '@/icons/payment-failed';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { useContext, useEffect } from 'react';

const RedeemFailed = (props: { onBack: () => void; errors: string }) => {
  const { event } = useContext(SoundContext);
  useEffect(() => {
    event.playPaymentFail();
  }, []);

  return (
    <div className="relative flex size-full flex-col items-center justify-center">
      <div className="flex w-full max-w-[480px] flex-none flex-col gap-10 text-center">
        <h2 className="mb-2 flex-none text-5xl font-bold">Redeem Failed!</h2>
        <div className="-mt-8 flex-none text-xl font-bold text-danger-discount">
          {props.errors}
        </div>
        <PaymentFailedIcon style={{ width: '480px', height: '304px' }} />
        <Button
          className="h-[96px] w-full bg-primary text-[32px]"
          onClick={() => props.onBack()}
        >
          Go back
        </Button>
      </div>
    </div>
  );
};
export default RedeemFailed;
